/* Code generated with AutoHTML Plugin for Figma */
import { useEffect, useState } from "react";
import TickSvg from "../../assets/taiga-uikit/icons/tick-square.svg?react";
import "./Clue.css";

export const Clue = ({ icon = null, is_visible = true, ...props }) => {
  const [isVisible, setIsVisible] = useState(is_visible);

  useEffect(() => {
    if (!isVisible) return;
    const timeout = setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
      }
    }, 500000);

    return () => clearTimeout(timeout);
  }, [isVisible]); // Выполняется

  return (
    <div className="clue-group">
      <div className={`clue ${isVisible ? "appear" : "disappear"}`}>
        {icon ? icon : <TickSvg />}
        <div className="clue-body">
          <div className="clue-text">{props.children}</div>
        </div>
      </div>
    </div>
  );
};
